import { Sparkles } from 'lucide-react';
import { useChatContext } from '../../contexts/ChatContext';
import { usePermissions } from '../../hooks/usePermissions';
import { PERMISSIONS } from '../../lib/permissions';
import ChatPanel from './ChatPanel';

export default function ChatWidget() {
  const { isOpen, setIsOpen } = useChatContext();
  const { can } = usePermissions();

  if (!can(PERMISSIONS.AI_CHAT)) return null;

  return (
    <>
      {/* Floating bubble */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 w-14 h-14 bg-brand text-white rounded-full shadow-lg hover:bg-brand-active hover:scale-105 transition-all flex items-center justify-center"
          title="Pracht AI Assistent"
        >
          <Sparkles className="w-6 h-6" />
        </button>
      )}

      {/* Chat panel */}
      <ChatPanel />
    </>
  );
}
